<template>
  <div class="ui-image"
       :style="radiusStyle"
       :class="[loading ? 'ui-image--loading' : '', error ? 'ui-image--error' : '']"
       @click="$emit('click')">
    <img class="ui-image__img"
         :class="[internal ? 'nio-invisible nio-internal' : '', fit === 'contain' ? 'contain' : '']"
         alt=""
         ref="img"
         :src="src"
         @error="handlerError"
         @load="handleLoad" />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '../../assets/images/logo.png'
    },
    // 开启app内点击图片放大限制
    internal: {
      type: Boolean,
      default: true
    },
    // 图片适应
    fit: {
      type: String,
      default: 'cover'
    },
    radius: {
      type: String,
      default: 'none'
    }
  },
  data(){
    return {
      loading: true,
      error: false
    };
  },
  computed: {
    radiusStyle(){
      return {
        borderRadius: this.radius
      };
    }
  },
  methods: {
    handlerError(){
      this.loading = false;
      this.error = true;
      this.$emit('error');
    },
    handleLoad(){
      if (this.$refs.img && this.$refs.img.complete){
        this.loading = false;
        this.error = false;
        this.$emit('load');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ui-image {
  width: 100%;
  height: 100%;
  overflow: hidden;

  &--loading, &--error {
    background-color: #F5F5F5;
    background-image: url('../../assets/images/logo.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 30%;

    .ui-image__img {
      opacity: 0;
    }
  }

  &__img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;

    &.contain {
      object-fit: contain;
    }
  }
}
</style>